module.exports = __webpack_public_path__ + "img/hamburger.da6a8c11.svg";